<template>
	<div class="container-wrap">
		<div class="container">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: `/news/${navId}` }">新闻</el-breadcrumb-item>
			  <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="main">
				<div class="content">
					<div class="content-title">
						{{detailModel.title}}
					</div>
					<div class="content-source">
						<span>作者：{{detailModel.author}}</span>
						<span class="content-time">发表于{{detailModel.addTime | datefmt('yyyy-MM-DD')}}</span>
					</div>
					<div class="content-abstracts">
						简介：{{detailModel.introduction}}
					</div>
					<div class="content-desc" v-html="detailModel.content">
					</div>
				</div>
				<div class="main-right">
					<Recommend @toDetail="toDetail" :list="recommendList" :imgList="recommendImg"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Recommend from '@/components/product/recommend'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	import recommendImg from '@/modules/product/recommendImg.js'
	export default {
		name: 'Home',
		components: {
			Recommend
		},
		mixins: [
			recommendImg
		],
		data() {
			return {
				id: '', //传过来的视频Id
				navId: '',  //传过来的视频栏目id
				detailModel: {},
				pageSize: 6,
				recommendList: []
			}
		},
		created(){
			let id = this.$route.params.id
			let navId = this.$route.params.navId
			this.id = id
			this.navId = navId
			this.getDetailData()
			this.getRecommendList()
			this.getRecommendImg()
		},
		methods: {
			//获取新闻推荐
			async getRecommendList(){
				let param = {
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/news/recommendList', qs.stringify(param))
				if(res.data.code==200){
					this.recommendList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取新闻详情
			async getDetailData(){
				let param = {
					id: this.id
				}
				ajaxParam(param)
				const res = await post('v1/news/info', qs.stringify(param))
				if(res.data.code==200){
					this.detailModel = res.data.entity
					document.title = this.detailModel.title
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//推荐跳转到详情
			toDetail(e){
				this.$router.push({
					path: '/newsDetail/'+this.navId+'/'+e.id
				})
				this.id = e.id
				this.getDetailData()
			}
		}
	}
</script>

<style scoped lang="less">
	.container{
		padding-top: 26px;
		padding-bottom: 26px;
		.main{
			margin-top: 26px;
			display: flex;
			justify-content: space-between;
			.content{
				width: 780px;
				background: #fff;
				border-radius: 5px;
				padding: 24px 24px 60px;
				box-sizing: border-box;
				.content-title{
					font-size: 28px;
					color: #37383c;
					letter-spacing: 1px;
					font-weight: 600;
					line-height: 40px;
				}
				.content-source{
					margin-top: 10px;
					margin-bottom: 17px;
					span{
						color: #37383c;
						letter-spacing: 1px;
						text-align: justify;
					}
					.content-time{
						padding-left: 22px;
						color: #8d8d8e
					}
				}
				.content-abstracts{
					margin-top: 32px;
					padding: 12px 23px;
					background: #f9f9f9;
					border-radius: 5px;
					color: #596069;
					line-height: 20px;
					font-weight: 500;
				}
				.content-desc{
					padding-top: 17px
				}
			}
			.card{
				width: 380px;
				min-height: 221px;
				background:#fff;
				margin-bottom: 20px;
				padding: 14px 23px 20px;
				border-radius: 5px;
				box-sizing: border-box;
				.card-title{
					font-size: 16px;
					letter-spacing: .57px;
					text-align: justify;
					font-weight: 600;
				}
				.card-line{
					width: 100%;
					height: 1px;
					background: #e5e6e9;
					margin-top: 7px;
				}
				.card-cnt li{
					height: 20px;
					margin-top: 13px;
					font-size: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					word-wrap: normal;
					text-align: justify;
				}
			}
		}
	}
</style>
